import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router  } from '@angular/router';
import { SharedService } from '../../_service/shared.service';
import { LeadsService } from '../../_service/leads.service';
import { LabService } from 'src/app/_service/lab.service';

@Component({
  selector: 'app-add-category',
  templateUrl: './add-category.component.html',
  styleUrls: ['./add-category.component.css']
})
export class AddCategoryComponent implements OnInit {
  categoryModalForm: FormGroup;loading:boolean=false;submitted:boolean=false;
  constructor(public dialogRef: MatDialogRef<AddCategoryComponent>,@Inject(MAT_DIALOG_DATA) public data: MatDialog,private dialog:MatDialog,
  private router:Router,private sharedapi:SharedService, private leadapi:LeadsService,private formBuilder: FormBuilder, private labapi: LabService) { 
    this.categoryModalForm = this.formBuilder.group({
      'lab_test_category': [null, Validators.required],
    });
  }

  ngOnInit(): void {
  }

  get f() { return this.categoryModalForm.controls; }

  CloseModal(): void {
    this.dialogRef.close();
  }

  async submitCategory()
  {
    this.submitted = true;
    this.loading = true;
    // stop here if form is invalid
    if (this.categoryModalForm.invalid) {
        this.loading = false;
        return;
    }
    //For Add Sub Category//
    await this.labapi.addCategory(this.categoryModalForm.value)
    .subscribe((data: any) => {
        this.submitted = false;
        this.loading = false;
        if (data.status) {
          this.dialogRef.close();
          this.sharedapi.presentToast('Category has been submitted successfully.');
        }
        else 
        {
          this.sharedapi.presentToast(data.msg);
        }
    }, error => {
        this.sharedapi.checkError(error);
    });
  }

}
